import styled from 'styled-components';
import { viewports } from 'app/shared/styles/_breakpoints';

import RenterProfileForm from 'app/shared/modules/RenterProfileForm';
import Text from 'app/shared/core/Text';

export const StyledRenterProfilePopup = styled.div`
  display: flex; /* Change to flex to create proper layout with sticky footer */
  flex-direction: column;
  position: relative;

  height: 100%; /* Take full modal height */
  padding: 16px;
  padding-bottom: 96px; /* Add padding to prevent overlap with fixed footer (16px padding + button height + margin) */
  width: 100%;
  box-sizing: border-box; /* Ensure padding is included in width calculations */
`;

export const ModalTitle = styled(Text)`
  flex-shrink: 0; /* Don't shrink the title */
  font-weight: 700;
  padding-top: 16px;
  text-align: center;
`;

export const ScrollWrapper = styled.div`
  flex: 1; /* Take remaining space above footer */
  overflow-y: auto; /* Allow scrolling within this area */
  overflow-x: hidden;
  padding-right: 8px; /* Account for scrollbar space */
  box-sizing: border-box;

  /* Custom scrollbar styles */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

export const StyledRenterProfileForm = styled(RenterProfileForm)`
  /* Let the form take up available space and be scrollable if needed */
  flex: 1 1 auto;
  min-height: 0; /* Allow flex shrinking */
`;

export const ButtonFooter = styled.footer`
  display: flex;
  flex-direction: row;
  gap: 8px;

  /* Fixed footer positioning */
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  background: white;
  padding: 16px;
  border-top: 1px solid #e5e7eb;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15); /* Enhanced shadow for better separation */
  z-index: 1001; /* Higher z-index to ensure it stays above scrollbar */
`;
